export const submitFunction = async (api, method, body, tokenINp) => {
  let response, data, token;
  token = tokenINp ? tokenINp : null;
  try {
    response = await fetch(`${process.env.REACT_APP_URL}${api}`, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: body,
    });
  } catch (error) {
    console.log(error);
  }
  data = await response.json();
  if (response.status === 422) {
    alert(data.data);
    return;
  }
  if (response.status === 404) {
    alert(data.data);
    return;
  }
  if (response.status === 403) {
    alert(data.data);
    return;
  }

  if (!response.ok) {
    return new Error(response.message);
  }

  return data.data;
};
